import sdk from '@/utils/Buryingpoint';
import LocalStore from '@/utils/store';

// sdk埋点(996魔方)
export const sdkBoxCollect = async (ch: string, params?: any) => {
  const info: any = LocalStore.getValue('React-ant-Admin-user');
  const uid = info.userinfo.id;
  const data = {
    eventname: ch,
    eventtype: 'track',
    uid,
    properities: { user_id: uid, ...params, page_type: 'pc' }
  };
  sdk.Burying(data);
};

// sdk埋点，批量
export const sdkBoxCollects = async (ch: string, params?: any) => {
  const info: any = LocalStore.getValue('React-ant-Admin-user');
  const uid = info.userinfo.id;
  const data = {
    name: ch,
    type: 'track',
    userId: uid,
    params: (params || []).map((item: any) => ({ ...item, user_id: uid }))
  };
  sdk.Buryings(data);
};

export interface ISellerPageClick {
  click_type: string;
  button_name?: string;
  game_id?: string;
  item_id?: number;
}
